module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/kp-2e79afa21a3e610e55511db40f3ef092.svg";